import { Box, Typography } from "@mui/material";
import { Check } from "lucide-react";

interface TimelineStep {
  number: number;
  title: string;
  description: string;
  isCheck?: boolean;
}
interface TimelineProps {
  steps: TimelineStep[];
}
export const Timeline = ({ steps }: TimelineProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      {steps.map((step, index) => (
        <Box key={step.number} sx={{ display: 'flex', gap: 2, position: 'relative' }}>
          <Box sx={{ 
            width: 32, 
            height: 32, 
            borderRadius: '50%', 
            bgcolor: step.isCheck ? '#FF69B4' : 'background.paper', 
            border: step.isCheck ? 'none' : '1px solid', 
            borderColor: 'secondary.main',
            color: step.isCheck ? '#FFFFFF' : 'secondary.main',
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            fontWeight: 600,
            fontSize: '0.875rem',
            flexShrink: 0
          }}>
            {step.isCheck ? <Check size={20} strokeWidth={3} /> : step.number}
          </Box>
          
          <Box sx={{ flex: 1 }}>
            <Typography variant="h3" sx={{ mb: 1 }}>
              {step.title}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {step.description}
            </Typography>
          </Box>
          
          {index < steps.length - 1 && (
            <Box sx={{ 
              position: 'absolute', 
              left: 16, 
              top: 32, 
              width: '1px', 
              height: 'calc(100% + 2rem)', 
              bgcolor: 'secondary.main',
              transform: 'translateX(-50%)'
            }} />
          )}
        </Box>
      ))}
    </Box>
  );
};